module.exports = __webpack_public_path__ + "static/media/headphones-alt.ecb2ac33.svg";